import type {
  FilterValue,
  FilterValues,
} from '@iconik-io/shared-lib/src/redux/common_filters/types';
import { guardMultiSelectFilter } from '@iconik-io/shared-lib/src/utils/search/guard_multi_select_filter';

const isFilterValueSet = (value: FilterValue | undefined): boolean => {
  if (value === undefined || value === null) {
    return false;
  }
  // Multi-select filters keep their value as an array of modifier groups. A
  // group with no items (e.g. a modifier was chosen but nothing selected yet)
  // does not count as a set filter.
  const multiSelect = guardMultiSelectFilter(value, {
    convertLegacyStrings: false,
  });
  if (multiSelect) {
    return multiSelect.some((group) => group.items.length > 0);
  }
  if (Array.isArray(value)) {
    return value.length > 0;
  }
  if (typeof value === 'object') {
    return Boolean(value.min) || Boolean(value.max);
  }
  return Boolean(value);
};

export const countSetMetadataFiltersForFields = (
  fields: { name: string }[] | undefined,
  filterValues: FilterValues,
): number => {
  if (!fields) {
    return 0;
  }
  let count = 0;
  for (const field of fields) {
    if (isFilterValueSet(filterValues[`metadata.${field.name}`])) {
      count += 1;
    }
  }
  return count;
};
